import romanApi, { type RomanApiError } from "@roman/shared/lib/net/romanApi";
import { useEffect } from "react";
import useSWRMutation from "swr/mutation";
import { type AuthHeader, useAuthHeader } from "./useAuthHeader";

type CountNumberOfReferralUsageArg = {
  referralCode: string;
};

type CountNumberOfReferralUsageResponse = {
  numberOfUses: number;
  freePointsEarned: string;
};

const fetcher = (url: string, { arg }: { arg: CountNumberOfReferralUsageArg }, headers: AuthHeader) =>
  romanApi.get<CountNumberOfReferralUsageResponse>(`${url}/${arg.referralCode}`, undefined, { headers });

export const useCountNumberOfReferralUsage = (handleError: (err: RomanApiError) => void) => {
  const header = useAuthHeader();
  const { data, error, trigger, isMutating } = useSWRMutation(
    "/referral/count",
    (url: string, args: { arg: CountNumberOfReferralUsageArg }) => fetcher(url, args, header),
  );

  useEffect(() => {
    if (error) {
      handleError(error);
    }
  }, [error, handleError]);

  return {
    data,
    isLoading: isMutating,
    error,
    trigger,
  };
};
